<style lang="scss" scoped>
@import "core";

.my-lead {
  margin-bottom: 15px;
}

.my-message {
  font-size: 90%;
  text-align: right;
}

.my-progress {}
</style>



<template>
  <dialog-base ref="base">
    <div slot="header" is="template">データをダウンロード中です</div>
    <div>
      <p class="my-lead">画面を閉じずに、そのままお待ちください</p>
<!--
      <div class="my-message" v-if="message">{{message}}</div>
-->
      <dn-progress-bar class="my-progress" v-model="inputValue" />
    </div>
  </dialog-base>
</template>



<script>
import DialogMixin from './dialogMixin';



export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: null,
    },
  },

  mixins: [DialogMixin],

  data() {
    return {
      inputValue: this.value,
    }
  },

  watch: {
    value() {
      this.inputValue = this.value;
    },
  },

  mounted() {
  },
}
</script>



// WEBPACK FOOTER //
// DialogDownload.vue?b773b6c8